<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-plus"></div>
    </div>
    <p langkey="phGroupOrder_Share_SubText"></p>
    <qr-code-display [qrData]="inviteQrCodesvg" [autoActivate]="true"></qr-code-display>
    <div class="ya-button-container">
      <button mat-flat-button (click)="closeBottomSheet()">
        <span langkey="phGroupOrder_Continue_Btn"></span>
      </button>
    </div>
  </div>
</div>